module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/AddInsight-4110465a465e7888127fae21a903feeb.jpg";